import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import toast from "react-hot-toast";
import { handleError } from "../../utils/handleError";

const ModalResetPassword = ({ open, setOpen, setLoading, userData }) => {
  const sendEmailResetPassword = async () => {
    try {
      setLoading(true);
      // Peticion a la API para enviar el enlace de recuperación de contraseña

      setLoading(false);
      setOpen(false);
      toast.success(
        `Enlace de recuperación de contraseña enviado a ${userData?.email}`
      );
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      setOpen(false);
      toast.error(`Error al enviar el enlace: ${message}`);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        ¿Desea enviar enlace al usuario {userData?.firstName} con correo:{" "}
        {userData?.email}?
      </DialogTitle>
      <DialogContent>
        <Typography>
          Al hacer clic en "Enviar enlace", se enviará un correo electrónico al
          usuario con instrucciones para restablecer su contraseña.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant="outlined" color="white">
          Cancelar
        </Button>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={sendEmailResetPassword}
        >
          Enviar enlace
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalResetPassword;
